// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionTableController from "./accordion_table_controller"
application.register("accordion-table", AccordionTableController)

import AccountHealth__ClientViewController from "./account_health/client_view_controller"
application.register("account-health--client-view", AccountHealth__ClientViewController)

import AccountHealth__CustomizeController from "./account_health/customize_controller"
application.register("account-health--customize", AccountHealth__CustomizeController)

import AccountHealth__RecordsWindowController from "./account_health/records_window_controller"
application.register("account-health--records-window", AccountHealth__RecordsWindowController)

import AccountTreeController from "./account_tree_controller"
application.register("account-tree", AccountTreeController)

import Accounts__DataSourcesSchemaController from "./accounts/data_sources_schema_controller"
application.register("accounts--data-sources-schema", Accounts__DataSourcesSchemaController)

import Admin__DmCoverageDonutController from "./admin/dm_coverage_donut_controller"
application.register("admin--dm-coverage-donut", Admin__DmCoverageDonutController)

import Admin__Menu__PipelinesTabController from "./admin/menu/pipelines_tab_controller"
application.register("admin--menu--pipelines-tab", Admin__Menu__PipelinesTabController)

import Admin__Menu__PlatformConnectionsTabController from "./admin/menu/platform_connections_tab_controller"
application.register("admin--menu--platform-connections-tab", Admin__Menu__PlatformConnectionsTabController)

import Admin__Menu__SearchAccountsController from "./admin/menu/search_accounts_controller"
application.register("admin--menu--search-accounts", Admin__Menu__SearchAccountsController)

import Admin__MenuController from "./admin/menu_controller"
application.register("admin--menu", Admin__MenuController)

import AdminDetectController from "./admin_detect_controller"
application.register("admin-detect", AdminDetectController)

import AdminSearchController from "./admin_search_controller"
application.register("admin-search", AdminSearchController)

import AgentChatController from "./agent_chat_controller"
application.register("agent-chat", AgentChatController)

import Attribution__DrawerSelectController from "./attribution/drawer_select_controller"
application.register("attribution--drawer-select", Attribution__DrawerSelectController)

import Attribution__PanelController from "./attribution/panel_controller"
application.register("attribution--panel", Attribution__PanelController)

import Attribution__SettingsFormController from "./attribution/settings_form_controller"
application.register("attribution--settings-form", Attribution__SettingsFormController)

import Attribution__TableLinkController from "./attribution/table_link_controller"
application.register("attribution--table-link", Attribution__TableLinkController)

import AuthorizationFormController from "./authorization_form_controller"
application.register("authorization-form", AuthorizationFormController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import BidCalculatorCampaignSelectorController from "./bid_calculator_campaign_selector_controller"
application.register("bid-calculator-campaign-selector", BidCalculatorCampaignSelectorController)

import BidCalculatorFormController from "./bid_calculator_form_controller"
application.register("bid-calculator-form", BidCalculatorFormController)

import BidCalculatorReportController from "./bid_calculator_report_controller"
application.register("bid-calculator-report", BidCalculatorReportController)

import BidCalculatorWizardController from "./bid_calculator_wizard_controller"
application.register("bid-calculator-wizard", BidCalculatorWizardController)

import BoostDashboard__HighlightController from "./boost_dashboard/highlight_controller"
application.register("boost-dashboard--highlight", BoostDashboard__HighlightController)

import CampaignCheckboxListController from "./campaign_checkbox_list_controller"
application.register("campaign-checkbox-list", CampaignCheckboxListController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckboxSubmitController from "./checkbox_submit_controller"
application.register("checkbox-submit", CheckboxSubmitController)

import ChecklistGroupsController from "./checklist_groups_controller"
application.register("checklist-groups", ChecklistGroupsController)

import ChecklistSortController from "./checklist_sort_controller"
application.register("checklist-sort", ChecklistSortController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import Cm360EnhancedConversionsValueController from "./cm360_enhanced_conversions_value_controller"
application.register("cm360-enhanced-conversions-value", Cm360EnhancedConversionsValueController)

import CodeHighlightController from "./code_highlight_controller"
application.register("code-highlight", CodeHighlightController)

import ColumnCheckboxController from "./column_checkbox_controller"
application.register("column-checkbox", ColumnCheckboxController)

import ConversionActions__AccountSelectController from "./conversion_actions/account_select_controller"
application.register("conversion-actions--account-select", ConversionActions__AccountSelectController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import ConversionActions__ComparisonModeToggleController from "./conversion_actions/comparison_mode_toggle_controller"
application.register("conversion-actions--comparison-mode-toggle", ConversionActions__ComparisonModeToggleController)

import ConversionActions__DetailTabsController from "./conversion_actions/detail_tabs_controller"
application.register("conversion-actions--detail-tabs", ConversionActions__DetailTabsController)

import ConversionActions__ExpandableRowController from "./conversion_actions/expandable_row_controller"
application.register("conversion-actions--expandable-row", ConversionActions__ExpandableRowController)

import ConversionActions__MasterDetailController from "./conversion_actions/master_detail_controller"
application.register("conversion-actions--master-detail", ConversionActions__MasterDetailController)

import ConversionActions__SortableController from "./conversion_actions/sortable_controller"
application.register("conversion-actions--sortable", ConversionActions__SortableController)

import ConversionActions__SwitchToggleController from "./conversion_actions/switch_toggle_controller"
application.register("conversion-actions--switch-toggle", ConversionActions__SwitchToggleController)

import ConversionEventsSortController from "./conversion_events_sort_controller"
application.register("conversion-events-sort", ConversionEventsSortController)

import ConversionSeriesToggleController from "./conversion_series_toggle_controller"
application.register("conversion-series-toggle", ConversionSeriesToggleController)

import CpdRegenerateWizardController from "./cpd_regenerate_wizard_controller"
application.register("cpd-regenerate-wizard", CpdRegenerateWizardController)

import CpdRerunWizardController from "./cpd_rerun_wizard_controller"
application.register("cpd-rerun-wizard", CpdRerunWizardController)

import CurrentLengthController from "./current_length_controller"
application.register("current-length", CurrentLengthController)

import CustomPropertiesController from "./custom_properties_controller"
application.register("custom-properties", CustomPropertiesController)

import Dashboard__CollapsibleController from "./dashboard/collapsible_controller"
application.register("dashboard--collapsible", Dashboard__CollapsibleController)

import DataExportFieldsController from "./data_export_fields_controller"
application.register("data-export-fields", DataExportFieldsController)

import DatasetModeToggleController from "./dataset_mode_toggle_controller"
application.register("dataset-mode-toggle", DatasetModeToggleController)

import DateAdjustmentController from "./date_adjustment_controller"
application.register("date-adjustment", DateAdjustmentController)

import DateOffsetController from "./date_offset_controller"
application.register("date-offset", DateOffsetController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DeliveryWindowController from "./delivery_window_controller"
application.register("delivery-window", DeliveryWindowController)

import Drawer__TouchedController from "./drawer/touched_controller"
application.register("drawer--touched", Drawer__TouchedController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DrawerFrameTriggerController from "./drawer_frame_trigger_controller"
application.register("drawer-frame-trigger", DrawerFrameTriggerController)

import DrawerInstanceController from "./drawer_instance_controller"
application.register("drawer-instance", DrawerInstanceController)

import DrawerTabsController from "./drawer_tabs_controller"
application.register("drawer-tabs", DrawerTabsController)

import DuplicateElementController from "./duplicate_element_controller"
application.register("duplicate-element", DuplicateElementController)

import Dv360AdvertiserLoaderController from "./dv360_advertiser_loader_controller"
application.register("dv360-advertiser-loader", Dv360AdvertiserLoaderController)

import EasepickController from "./easepick_controller"
application.register("easepick", EasepickController)

import EmqDrawerController from "./emq_drawer_controller"
application.register("emq-drawer", EmqDrawerController)

import EnumValidationOptionsFormController from "./enum_validation_options_form_controller"
application.register("enum-validation-options-form", EnumValidationOptionsFormController)

import ErrorTimeoutController from "./error_timeout_controller"
application.register("error-timeout", ErrorTimeoutController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import ExportConfigurationFormController from "./export_configuration_form_controller"
application.register("export-configuration-form", ExportConfigurationFormController)

import FieldTransformationDrawerController from "./field_transformation_drawer_controller"
application.register("field-transformation-drawer", FieldTransformationDrawerController)

import FieldTransformationsController from "./field_transformations_controller"
application.register("field-transformations", FieldTransformationsController)

import FieldTransformationsSortController from "./field_transformations_sort_controller"
application.register("field-transformations-sort", FieldTransformationsSortController)

import FintelStatusMapController from "./fintel_status_map_controller"
application.register("fintel-status-map", FintelStatusMapController)

import GroupOperationsController from "./group_operations_controller"
application.register("group-operations", GroupOperationsController)

import HeatMapMenusController from "./heat_map_menus_controller"
application.register("heat-map-menus", HeatMapMenusController)

import HeatMapTipController from "./heat_map_tip_controller"
application.register("heat-map-tip", HeatMapTipController)

import HierarchicalCheckboxController from "./hierarchical_checkbox_controller"
application.register("hierarchical-checkbox", HierarchicalCheckboxController)

import HubspotPropertyPickerController from "./hubspot_property_picker_controller"
application.register("hubspot-property-picker", HubspotPropertyPickerController)

import InlineSearchController from "./inline_search_controller"
application.register("inline-search", InlineSearchController)

import IqrChartController from "./iqr_chart_controller"
application.register("iqr-chart", IqrChartController)

import IqrChartWrapperController from "./iqr_chart_wrapper_controller"
application.register("iqr-chart-wrapper", IqrChartWrapperController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import MappedFieldValidationController from "./mapped_field_validation_controller"
application.register("mapped-field-validation", MappedFieldValidationController)

import MetricFilterController from "./metric_filter_controller"
application.register("metric-filter", MetricFilterController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModelingPerformanceWizardController from "./modeling_performance_wizard_controller"
application.register("modeling-performance-wizard", ModelingPerformanceWizardController)

import NavAccountSelectorController from "./nav_account_selector_controller"
application.register("nav-account-selector", NavAccountSelectorController)

import NavDatePickerController from "./nav_date_picker_controller"
application.register("nav-date-picker", NavDatePickerController)

import NavProfileDropdownController from "./nav_profile_dropdown_controller"
application.register("nav-profile-dropdown", NavProfileDropdownController)

import ObjectSelectorController from "./object_selector_controller"
application.register("object-selector", ObjectSelectorController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PipelineDestinationsGroupCopyController from "./pipeline_destinations_group_copy_controller"
application.register("pipeline-destinations-group-copy", PipelineDestinationsGroupCopyController)

import PipelineDestinationsValidatorController from "./pipeline_destinations_validator_controller"
application.register("pipeline-destinations-validator", PipelineDestinationsValidatorController)

import PipelineScheduleController from "./pipeline_schedule_controller"
application.register("pipeline-schedule", PipelineScheduleController)

import DataSourceFieldsController from "./data_source_fields_controller"
application.register("data-source-fields", DataSourceFieldsController)

import PlatformSyncedLockController from "./platform_synced_lock_controller"
application.register("platform-synced-lock", PlatformSyncedLockController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PredictAutoRefreshController from "./predict_auto_refresh_controller"
application.register("predict-auto-refresh", PredictAutoRefreshController)

import PredictBacktestFormController from "./predict_backtest_form_controller"
application.register("predict-backtest-form", PredictBacktestFormController)

import PredictBacktestResultsController from "./predict_backtest_results_controller"
application.register("predict-backtest-results", PredictBacktestResultsController)

import PredictClipboardController from "./predict_clipboard_controller"
application.register("predict-clipboard", PredictClipboardController)

import PredictCommandFormController from "./predict_command_form_controller"
application.register("predict-command-form", PredictCommandFormController)

import PredictConfigFormController from "./predict_config_form_controller"
application.register("predict-config-form", PredictConfigFormController)

import PredictElapsedController from "./predict_elapsed_controller"
application.register("predict-elapsed", PredictElapsedController)

import PredictScheduleFormController from "./predict_schedule_form_controller"
application.register("predict-schedule-form", PredictScheduleFormController)

import PredictWorkspaceFormController from "./predict_workspace_form_controller"
application.register("predict-workspace-form", PredictWorkspaceFormController)

import ProviderTabsController from "./provider_tabs_controller"
application.register("provider-tabs", ProviderTabsController)

import Reporting__CheckboxGroupController from "./reporting/checkbox_group_controller"
application.register("reporting--checkbox-group", Reporting__CheckboxGroupController)

import Reporting__ConversionBreakdownController from "./reporting/conversion_breakdown_controller"
application.register("reporting--conversion-breakdown", Reporting__ConversionBreakdownController)

import Reporting__ConversionMatrixController from "./reporting/conversion_matrix_controller"
application.register("reporting--conversion-matrix", Reporting__ConversionMatrixController)

import Reporting__DeferredFrameController from "./reporting/deferred_frame_controller"
application.register("reporting--deferred-frame", Reporting__DeferredFrameController)

import Reporting__ExperimentTrendChartController from "./reporting/experiment_trend_chart_controller"
application.register("reporting--experiment-trend-chart", Reporting__ExperimentTrendChartController)

import Reporting__FilterBuilderController from "./reporting/filter_builder_controller"
application.register("reporting--filter-builder", Reporting__FilterBuilderController)

import Reporting__FilterFormController from "./reporting/filter_form_controller"
application.register("reporting--filter-form", Reporting__FilterFormController)

import Reporting__SavedReportsController from "./reporting/saved_reports_controller"
application.register("reporting--saved-reports", Reporting__SavedReportsController)

import Reporting__SegmentModeController from "./reporting/segment_mode_controller"
application.register("reporting--segment-mode", Reporting__SegmentModeController)

import Reporting__TimeSeriesChartController from "./reporting/time_series_chart_controller"
application.register("reporting--time-series-chart", Reporting__TimeSeriesChartController)

import ReportingAccountSelectorController from "./reporting_account_selector_controller"
application.register("reporting-account-selector", ReportingAccountSelectorController)

import ReportingV2ConfigController from "./reporting_v2_config_controller"
application.register("reporting-v2-config", ReportingV2ConfigController)

import ResolvedConfigurationPreviewController from "./resolved_configuration_preview_controller"
application.register("resolved-configuration-preview", ResolvedConfigurationPreviewController)

import RowCheckboxController from "./row_checkbox_controller"
application.register("row-checkbox", RowCheckboxController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import RulePassRateChartController from "./rule_pass_rate_chart_controller"
application.register("rule-pass-rate-chart", RulePassRateChartController)

import RuleSelectController from "./rule_select_controller"
application.register("rule-select", RuleSelectController)

import VocabularyMatchPreviewController from "./vocabulary_match_preview_controller"
application.register("vocabulary-match-preview", VocabularyMatchPreviewController)

import SalesforceObjectFieldController from "./salesforce_object_field_controller"
application.register("salesforce-object-field", SalesforceObjectFieldController)

import SalesforceRoutingController from "./salesforce_routing_controller"
application.register("salesforce-routing", SalesforceRoutingController)

import ScheduleToggleController from "./schedule_toggle_controller"
application.register("schedule-toggle", ScheduleToggleController)

import SchemaDrawerHiddenRowController from "./schema_drawer_hidden_row_controller"
application.register("schema-drawer-hidden-row", SchemaDrawerHiddenRowController)

import SchemaExtraFieldFormController from "./schema_extra_field_form_controller"
application.register("schema-extra-field-form", SchemaExtraFieldFormController)

import SchemaFieldEditDrawerController from "./schema_field_edit_drawer_controller"
application.register("schema-field-edit-drawer", SchemaFieldEditDrawerController)

import ScrollHighlightController from "./scroll_highlight_controller"
application.register("scroll-highlight", ScrollHighlightController)

import SearchSelectController from "./search_select_controller"
application.register("search-select", SearchSelectController)

import SeeMoreController from "./see_more_controller"
application.register("see-more", SeeMoreController)

import SelectReloadController from "./select_reload_controller"
application.register("select-reload", SelectReloadController)

import SelfDestructController from "./self_destruct_controller"
application.register("self-destruct", SelfDestructController)

import SettingsSelectNextController from "./settings_select_next_controller"
application.register("settings-select-next", SettingsSelectNextController)

import SftpAuthMethodController from "./sftp_auth_method_controller"
application.register("sftp-auth-method", SftpAuthMethodController)

import SheetsExportController from "./sheets_export_controller"
application.register("sheets-export", SheetsExportController)

import SidebarCollapseController from "./sidebar_collapse_controller"
application.register("sidebar-collapse", SidebarCollapseController)

import SidebarNavGroupController from "./sidebar_nav_group_controller"
application.register("sidebar-nav-group", SidebarNavGroupController)

import SoqlQueryEditorController from "./soql_query_editor_controller"
application.register("soql-query-editor", SoqlQueryEditorController)

import StepperStepController from "./stepper_step_controller"
application.register("stepper-step", StepperStepController)

import StringValidatorOptionsController from "./string_validator_options_controller"
application.register("string-validator-options", StringValidatorOptionsController)

import SubscribeGateController from "./subscribe_gate_controller"
application.register("subscribe-gate", SubscribeGateController)

import TableEditController from "./table_edit_controller"
application.register("table-edit", TableEditController)

import TableResizeController from "./table_resize_controller"
application.register("table-resize", TableResizeController)

import TableRowDisclosureController from "./table_row_disclosure_controller"
application.register("table-row-disclosure", TableRowDisclosureController)

import TableSearchController from "./table_search_controller"
application.register("table-search", TableSearchController)

import TableSelectController from "./table_select_controller"
application.register("table-select", TableSelectController)

import TableToCsvController from "./table_to_csv_controller"
application.register("table-to-csv", TableToCsvController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TermsGateController from "./terms_gate_controller"
application.register("terms-gate", TermsGateController)

import TimeOffsetController from "./time_offset_controller"
application.register("time-offset", TimeOffsetController)

import TipOpenAsyncController from "./tip_open_async_controller"
application.register("tip-open-async", TipOpenAsyncController)

import TipOpenController from "./tip_open_controller"
application.register("tip-open", TipOpenController)

import ToggleElementController from "./toggle_element_controller"
application.register("toggle-element", ToggleElementController)

import TransformDrawerController from "./transform_drawer_controller"
application.register("transform-drawer", TransformDrawerController)

import TurboLoaderController from "./turbo_loader_controller"
application.register("turbo-loader", TurboLoaderController)

import UetTagLinkController from "./uet_tag_link_controller"
application.register("uet-tag-link", UetTagLinkController)

import UserCreationFormController from "./user_creation_form_controller"
application.register("user-creation-form", UserCreationFormController)

import V2StepperController from "./v2_stepper_controller"
application.register("v2-stepper", V2StepperController)
